import gsap from 'gsap';
import MorphSvg from '../../../lib/morphSvg';

const commonValues = {
  duration: 0.5,
};

export default function animateChevron({ arrowPathRef, linePathRef }) {
  gsap.registerPlugin(MorphSvg);

  gsap.set(linePathRef.current, { opacity: 0 });

  let mainTl = gsap
    .timeline({ yoyo: true, paused: true })
    .add(morphSvgPath({ arrowPathRef, linePathRef }));

  let secondTl = gsap
    .timeline({ paused: true })
    .add(morphSvgPathReverse({ arrowPathRef }));

  return { startTl: mainTl, reverseTl: secondTl };
}

function morphSvgPath({ arrowPathRef, linePathRef }) {
  let tl = gsap.timeline({ id: 'internal' });

  tl.to(arrowPathRef.current, {
    ...commonValues,
    morphSVG: linePathRef.current,
    ease: 'ease-out',
  });

  return tl;
}

function morphSvgPathReverse({ arrowPathRef }) {
  let tl = gsap.timeline({ id: 'internal' });

  tl.to(arrowPathRef.current, {
    ...commonValues,
    morphSVG: arrowPathRef.current,
    ease: 'ease-in',
  });

  return tl;
}
